import {
  Obj,
  Opt,
  ShallowMapFieldsNullToOpt,
} from 'app/tools/general.types';
import { AxiosError } from 'axios';
import _ from 'lodash';
import {
  CamelCasedPropertiesDeep,
  JsonObject,
  Merge,
  SnakeCasedPropertiesDeep,
} from 'type-fest';

export type RawApi<T> = SnakeCasedPropertiesDeep<T>;
// NOTE: KeyedApi<T> should be exactly the same as T, but with
// generic type T the compiler can't tell and so this type is needed
// occasionally to wrap return types accordingly.
export type KeyedApi<T> = CamelCasedPropertiesDeep<RawApi<T>>;
export type MappedApi<T> = ShallowMapFieldsNullToOpt<KeyedApi<T>>;

export type DetailKey = 'detail';
export type NoContent = '';
export type StatusResp = {
  status: string;
};

export type PatchObject<T> = { id: number; data: Partial<T> };

export type FormDataSource = Obj<string | number | File>;

export const isFormDataSource = (
  data: JsonObject | FormDataSource
): data is FormDataSource =>
  _.values(data).some(v => v instanceof File);

//
// ---------------------- API ERROR TYPES ------------------------

export type NonFieldErrorKey = 'nonFieldErrors';
export type AcceptAnyArrayKey<T> = Merge<
  { [x: string]: string[] },
  T
>;

export type RawApiError = AcceptAnyArrayKey<
  RawApi<{
    detail?: string;
    nonFieldErrors?: string[];
  }>
>;
export type ApiErrorWithNonFieldErrors = AcceptAnyArrayKey<{
  detail?: string;
  nonFieldErrors?: string[];
}>;
export type ApiError = {
  detail?: string;
  [x: string]: Opt<string>;
};
export interface KeyedApiAxiosError extends AxiosError<ApiError> {
  isKeyedAxiosError: true;
  data: ApiError;
}

export type ApiInfoRtn = { [x in DetailKey]?: string };

export const isAxiosError = <T>(input: T): input is T & AxiosError =>
  input && 'isAxiosError' in input;

export const isKeyedAxiosError = <T>(
  input: T
): input is T & KeyedApiAxiosError =>
  input && 'isKeyedAxiosError' in input;
